<script>
    import { onMount } from 'svelte'
    import { fly } from 'svelte/transition'
    import { flyModified } from '../../js/transitions.js'
    import { handleHashChange } from '../../js/hash-scroll.js'
    import Person from '../content-types/Person.svelte'
    import Alumni from '../content-types/Alumni.svelte'

    export let page

    onMount(handleHashChange) // init scroll position on mount
</script>

<div id="peopleContent" out:flyModified={{ y: 10, duration: 400, position: 'absolute' }}>
    <h2 id="faculty" class="sectionTitle" style="color: {page.circuit_color};">
        Faculty
    </h2>
    {#each page.people.filter(person => person.category == 'FA') as person}
        <Person {person} color={page.circuit_color} />
    {/each}

    <h2 id="postdocs" class="sectionTitle" style="color: {page.circuit_color};">
        Postdocs
    </h2>
    <div class="peopleSection">
        {#each page.people.filter(person => person.category == 'PD') as person}
            <Person {person} color={page.circuit_color} />
        {/each}
    </div>

    <h2 class="sectionTitle" id="gradstudents" style="color: {page.circuit_color};">
        Grad Students
    </h2>
    <div class="peopleSection">
        {#each page.people.filter(person => person.category == 'GS') as person}
            <Person {person} color={page.circuit_color} />
        {/each}
    </div>

    <h2 class="sectionTitle" id="staff" style="color: {page.circuit_color};">
        Staff
    </h2>
    <div class="peopleSection">
        {#each page.people.filter(person => person.category == 'ST') as person}
            <Person {person} color={page.circuit_color} />
        {/each}
    </div>

    <h2 class="sectionTitle" id="alumni" style="color: {page.circuit_color};">
        Alumni
    </h2>
    <div class="peopleSection">
        {#if page.people.filter(person => person.category == 'AL' && person.alumniCategory == 'PD').length > 0}
            <h3>Post Docs</h3>
            {#each page.people.filter(person => person.category == 'AL' && person.alumniCategory == 'PD') as person}
                <Alumni {person} />
            {/each}
        {/if}
        {#if page.people.filter(person => person.category == 'AL' && person.alumniCategory == 'GS').length > 0}
            <h3>Grad Students</h3>
            {#each page.people.filter(person => person.category == 'AL' && person.alumniCategory == 'GS') as person}
                <Alumni {person} />
            {/each}
        {/if}
        {#if page.people.filter(person => person.category == 'AL' && person.alumniCategory == 'ST').length > 0}
            <h3>Staff</h3>
            {#each page.people.filter(person => person.category == 'AL' && person.alumniCategory == 'ST') as person}
                <Alumni {person} />
            {/each}
        {/if}
        {#if page.people.filter(person => person.category == 'AL' && person.alumniCategory == 'NO').length > 0}
            <br />
            {#each page.people.filter(person => person.category == 'AL' && person.alumniCategory == 'NO') as person}
                <Alumni {person} />
            {/each}
        {/if}
    </div>

    <h2 class="sectionTitle" id="contact" style="color: {page.circuit_color};">
        Contact
    </h2>
    <div class="contact">
        {@html page.contacts}
        {#each page.social_media as social}
            <a href={social.value.url} target="_blank">
                Find us on {social.value.social_media}
            </a>
        {/each}
    </div>
</div>

<style lang="scss">
    @import "../../styles/vars";

    .sectionTitle:first-of-type {
        margin-top: 0;
    }

    h3 {
        font-family: "Ysabeau";
        font-weight: bold;
        font-size: 1.5rem;
        margin-top: 1rem;
        margin-bottom: 0;
    }

    #faculty {
        margin-top: 0;
    }

    #peopleContent {
        box-sizing: border-box;
        position: relative;
        width: 50vw;
        margin: 0 25vw;
        top: 0;
        padding: 50px 0;
    }

    .peopleSection {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        column-gap: 40px;
    }

    .contact {
            color: black !important;
            text-decoration: none !important;
            font-family: "Ysabeau";
            margin: 0;

        &:hover {
            text-decoration: none;
        }
    }

    :global(.contact a) {
        text-decoration: underline;
        color: black;
    }

    @include respond-to(phone) {
        .peopleSection {
            display: grid;
            grid-template-columns:1fr 1fr 1fr;
            column-gap: 10px;
        }

        #peopleContent {
            width: 96vw;
            margin: 0 2vw 50px;
            padding-top: 0;
        }
    }
</style>
